export type ServiceHealthState = 'operational' | 'degraded'

const LOCAL_DEV_BACKEND_ORIGIN = 'http://localhost:8080'

export function deriveServiceHealthState(
	healthCheckResponse: 'Healthy' | 'Unhealthy' | undefined
): ServiceHealthState {
	return healthCheckResponse === 'Healthy' ? 'operational' : 'degraded'
}

export function resolveServiceHealthBaseUrl({
	apiEndpoint,
	isDev
}: {
	apiEndpoint: string
	isDev: boolean
}) {
	if (apiEndpoint) {
		return apiEndpoint
	}

	return isDev ? LOCAL_DEV_BACKEND_ORIGIN : ''
}

export async function resolveServiceHealthStateFromCheck({
	healthCheck,
	timeoutMs
}: {
	healthCheck: (
		signal: AbortSignal
	) => Promise<'Healthy' | 'Unhealthy' | undefined>
	timeoutMs: number
}) {
	const abortController = new AbortController()
	const timeout = setTimeout(() => abortController.abort(), timeoutMs)

	try {
		const response = await healthCheck(abortController.signal)
		return deriveServiceHealthState(response)
	} catch {
		return deriveServiceHealthState(undefined)
	} finally {
		clearTimeout(timeout)
	}
}
